var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.801 12.874c1.43 0 2.82-.477 3.948-1.356l4.256 4.257a.8.8 0 001.132-1.132l-4.256-4.257a6.438 6.438 0 00-1.135-9.032 6.438 6.438 0 10-3.945 11.52zm-3.42-9.857a4.836 4.836 0 116.84 6.842 4.836 4.836 0 01-6.84 0 4.82 4.82 0 010-6.842z",
    fill: "#7E96AE"
  })));
}
export default SvgSearchLogo;